/* assets/section-giddy-homepage.js */
/* Homepage interactions — now data-attribute driven so each product card binds
   to its own variant/handle (set by the Liquid blocks loop in
   sections/giddy-homepage.liquid). No hardcoded variant or handle arrays. */
(function () {
  'use strict';

  // ── Scroll reveal ───────────────────────────────────────────
  var revealEls = document.querySelectorAll(
    '.reveal-on-scroll, .reveal, .reveal-up, .reveal-fade, ' +
    '.reveal-scale, .reveal-pop, .reveal-left, .reveal-right'
  );
  // Trigger reveals earlier on mobile so sections don't feel slow to appear.
  // Mobile: fire ~80px before the element reaches the viewport, no threshold.
  // Desktop: unchanged (waits until 12% in, 40px past the bottom edge).
  var revealOpts = window.matchMedia('(max-width: 749px)').matches
    ? { threshold: 0, rootMargin: '0px 0px 80px 0px' }
    : { threshold: 0.12, rootMargin: '0px 0px -40px 0px' };
  if ('IntersectionObserver' in window) {
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            // Element entered the viewport → reveal it
            e.target.classList.add('is-visible');
          } else {
            // Element left the viewport. Only un-reveal if it left by going
            // BELOW the viewport (user scrolled UP past it). If it left by
            // going ABOVE the viewport (user scrolled DOWN past it), keep it
            // visible so sections behind us stay visible.
            // boundingClientRect.top > 0 means the element is currently
            // positioned below the viewport top — i.e., below us.
            if (e.boundingClientRect.top > 0) {
              e.target.classList.remove('is-visible');
            }
          }
        });
      },
      revealOpts
    );
    revealEls.forEach((el) => io.observe(el));
  } else {
    revealEls.forEach((el) => el.classList.add('is-visible'));
  }

  // ── Product card image area click → product page ────────────
  document.querySelectorAll('.product-card').forEach(function (card) {
    var handle = card.dataset.handle;
    if (!handle) return;
    var imgArea = card.querySelector('.prod-img');
    if (imgArea) {
      imgArea.style.cursor = 'pointer';
      imgArea.addEventListener('click', function () {
        window.location.href = '/products/' + handle;
      });
    }
  });

  // ── Add to Cart → Shopify AJAX, reads variant from the button ──
  document.querySelectorAll('.prod-btn').forEach(function (btn) {
    if (btn.disabled) return;
    btn.addEventListener('click', function (e) {
      e.stopPropagation();
      var variantId = this.dataset.variant;
      var handle = this.dataset.handle;
      if (!variantId) {
        if (handle) window.location.href = '/products/' + handle;
        return;
      }
      var orig = this.textContent;
      var el = this;
      el.textContent = 'Adding…';
      el.disabled = true;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      })
        .then(function (r) { return r.json(); })
        .then(function () {
          el.textContent = 'Added! ✓';
          el.style.background = '#3D2010';
          el.style.color = '#FDF7EE';
          // Keep the theme header's cart count in sync
          fetch('/cart.js')
            .then(function (r) { return r.json(); })
            .then(function (cart) {
              document
                .querySelectorAll('.cart-count-bubble span[aria-hidden="true"]')
                .forEach(function (b) { b.textContent = cart.item_count; });
            })
            .catch(function () {});
          setTimeout(function () {
            el.textContent = 'Add to Cart';
            el.style.background = '';
            el.style.color = '';
            el.disabled = false;
          }, 2000);
        })
        .catch(function () {
          el.textContent = 'Add to Cart';
          el.disabled = false;
          if (handle) window.location.href = '/products/' + handle;
        });
    });
  });

  // ── Newsletter form ─────────────────────────────────────────
  const nlSubmit = document.querySelector('.nl-submit');
  const nlInput = document.querySelector('.nl-input');
  if (nlSubmit && nlInput) {
    nlSubmit.addEventListener('click', function () {
      const email = nlInput.value.trim();
      if (!email || !email.includes('@')) {
        nlInput.style.border = '2px solid #FF6B6B';
        nlInput.placeholder = 'Please enter a valid email';
        return;
      }
      nlInput.style.border = '';
      this.textContent = "You're in! 🎉";
      this.disabled = true;
      nlInput.value = '';
    });
  }
})();
